export var getExamplesFromSpec = function (examples, type) {
    return examples.map(function (el) { return el[type]; }).filter(Boolean);
};
//# sourceMappingURL=getExamplesFromSpec.js.map